module.exports = __webpack_public_path__ + "img/illlo_4.72517330.svg";